'use client'
import { jsx } from "react/jsx-runtime";
import { image as external_ImageVariants_js_image } from "./ImageVariants.js";
const DEFAULT_IMAGE = 'https://s1.pclncdn.com/design-assets/brand-assets/default_image.jpeg';
const Image = ({ src = DEFAULT_IMAGE, alt, width, maxWidth, height, maxHeight, ratio, borderRadius, shadow, objectFit, objectPosition, isLoading, className, isSvg, ...props })=>{
    const classes = external_ImageVariants_js_image({
        width,
        maxWidth,
        height,
        maxHeight,
        ratio,
        borderRadius,
        shadow,
        objectFit,
        objectPosition,
        isLoading,
        className,
        isSvg
    });
    const combinedClasses = ratio ? `${classes} aspect-${ratio}` : classes;
    return /*#__PURE__*/ jsx("img", {
        src: src,
        alt: alt,
        className: combinedClasses,
        ...props,
        style: {
            aspectRatio: ratio
        },
        decoding: "async"
    });
};
export { Image };
